import { Input } from "@contractor-quoting/shared-ui";

export function FeetInchesInput({
  label,
  millimetres,
  onChange,
}: {
  label: string;
  millimetres: number;
  onChange(value: number): void;
}) {
  const totalInches = millimetres / 25.4;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches - feet * 12);
  return (
    <fieldset>
      <legend className="mb-2 font-semibold text-stone-800">{label}</legend>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-sm text-stone-600">
          Feet
          <Input
            inputMode="numeric"
            min={0}
            type="number"
            value={feet}
            onChange={(event) =>
              onChange(Math.round((Number(event.target.value) * 12 + inches) * 25.4))
            }
          />
        </label>
        <label className="text-sm text-stone-600">
          Inches
          <Input
            inputMode="numeric"
            min={0}
            max={11}
            type="number"
            value={inches}
            onChange={(event) =>
              onChange(Math.round((feet * 12 + Number(event.target.value)) * 25.4))
            }
          />
        </label>
      </div>
    </fieldset>
  );
}
